/**
 * Photo Wallpaper Crop Guide
 *
 * Calculator + crop modal for photo-wallpaper products.
 * Configuration is passed from Liquid via data-attributes on the custom element.
 * No product handles are hardcoded in JS.
 */

(function () {
  if (window.customElements.get('photo-wallpaper-crop-guide')) return;

  class PhotoWallpaperCropGuide extends HTMLElement {
    connectedCallback() {
      this._formId = this.dataset.formId;
      this._productHandle = this.dataset.productHandle;

      try { this._variants = JSON.parse(this.dataset.variants || '[]'); } catch (_) { this._variants = []; }
      try { this._optionNames = JSON.parse(this.dataset.optionNames || '[]'); } catch (_) { this._optionNames = []; }
	      this._firstImage = this.dataset.firstImage || '';
	      this._initialVariantId = null;

      // State
      this._wallWidth = 0;
      this._wallHeight = 0;
      this._recommendedVariant = null;
      this._cropX = 0;
      this._cropY = 0;
	      this._cropConfirmed = false;
	      this._assistedActive = false;
	      this._calculatorOpened = false;
	      this._manualMode = false;
	      this._manualConfirmed = false;
	      this._isDragging = false;
      this._dragStartX = 0;
      this._dragStartY = 0;
      this._dragOffsetX = 0;
      this._dragOffsetY = 0;

      // Preview coordinate state
      this._previewScaleX = 1;
      this._previewScaleY = 1;
      this._previewOffsetX = 0;
      this._previewOffsetY = 0;
      this._standardWidth = 0;
      this._standardHeight = 0;
      this._trimLeft = 0;
      this._trimRight = 0;
      this._trimTop = 0;
      this._trimBottom = 0;

      // Bound handlers
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp = this._onPointerUp.bind(this);
      this._onWindowResize = this._onWindowResize.bind(this);

      this._init();
    }

    /* ------------------------------------------------------------------ */
    /*  Init                                                               */
    /* ------------------------------------------------------------------ */

	    _init() {
	      this._form = this._findForm();
	      if (!this._form) return;
	      this._initialVariantId = this._currentVariantId();

	      this._stepper = this._form.closest('.nt-photo-product') && this._form.closest('.nt-photo-product').querySelector('[data-pw-cg-stepper]');
	      this._modalElement = this.querySelector('.pw-cg__modal');
	      this._stage = 'init';

	      // Move the variant-picker block into the stepper's step-2 slot.
	      // The stepper is rendered OUTSIDE the [data-block-type="variant-picker"]
	      // div so Prestige's product:rerender replaces the variant-picker
	      // IN PLACE (inside the slot) without destroying the stepper or
	      // crop-guide DOM + JS state.
	      if (this._stepper) {
	        // Hide the separate buy-buttons block — the stepper's step-3
	        // submit button (form="product_form_id") is the visible CTA.
	        var bbBlock = document.querySelector('[data-block-type="buy-buttons"]');
	        if (bbBlock) bbBlock.style.display = 'none';
	        var slot = this._stepper.querySelector('[data-pw-cg-variant-picker-slot]');
	        if (slot) {
	          var vp = document.querySelector('[data-block-type="variant-picker"]');
	          if (vp && slot.children.length === 0) {
	            slot.appendChild(vp);
	          }
	        }
	      }

	      this._syncStage();

	      if (this._stepper) {
	        var self = this;
	        this._stepper.querySelectorAll('[data-pw-cg-open-crop]').forEach(function (btn) {
	          btn.addEventListener('click', function () { self._openModal(); });
	        });
	        this._stepper.querySelectorAll('[data-pw-cg-ret]').forEach(function (btn) {
	          btn.addEventListener('click', function (e) {
	            e.preventDefault();
	            var target = btn.getAttribute('data-pw-cg-ret');
	            if (target === 'size') self._retToSizeStep();
	            else if (target === 'recommend') self._retToRecommendStep();
	          });
	        });
	      }

	      // Intercept form submit when the fototapet confirmation flow is incomplete.
	      this._form.addEventListener('submit', (e) => {
	        if (this._assistedActive && !this._cropConfirmed) {
	          e.preventDefault();
	          e.stopPropagation();
	          this._updateBuyButtonState();
	          return false;
	        }

	        if (this._assistedActive && this._cropConfirmed) {
	          this._event('assisted_add_to_cart', this._eventPayload());
	        } else if (this._manualConfirmed) {
	          this._updateManualFormProperties();
	        } else {
	          e.preventDefault();
	          e.stopPropagation();
	          this._manualMode = true;
	          this._updateBuyButtonState();
	          return false;
	        }
	      }, { capture: true });

      // Listen for variant changes — pure observer, no writes back to the form.
      // When the manual panel is open, enables the confirm button + updates card
      // selected state. For assisted flow, handles material-change recovery.
      this._form.addEventListener('variant:change', (e) => {
        const v = e.detail && e.detail.variant;
        if (!v) return;

        if (this._manualMode) {
          // Manual panel is open — user picked a size card, which ticked the
          // hidden Prestige radio. Prestige resolved the variant. Enable confirm.
          if (this._manualConfirmBtn) this._manualConfirmBtn.disabled = false;
          this._updateMainPriceDisplay(v);
          return;
        }

        // After manual confirm, material change should update price display
        // and the step-3 buy card (Totalpris + material label)
        if (this._manualConfirmed) {
          this._updateMainPriceDisplay(v);
          this._updateBuyButtonState();
          this._setStepRecommendContent();
          this._setStepBuyContent();
          return;
        }

        if (v && this._recommendedVariant && v.id !== this._recommendedVariant.id && this._assistedActive) {
          if (this._syncRecommendationAfterMaterialChange(v)) return;
          this._enterManualMode(v);
        }
      });

      // Calculator button
      const calc = this.querySelector('.pw-cg__calc');
      if (calc) {
        calc.addEventListener('focusin', () => this._trackCalculatorOpened(), { once: true });
        calc.addEventListener('pointerdown', () => this._trackCalculatorOpened(), { once: true });
      }

	      const calcBtn = this.querySelector('.pw-cg__calc-btn');
	      if (calcBtn) calcBtn.addEventListener('click', () => this._calculate());

	      const resetBtn = this.querySelector('.pw-cg__reset-btn');
	      if (resetBtn) resetBtn.addEventListener('click', () => this._resetFlow());

      // Enter key on inputs
	      const wInput = this.querySelector('.pw-cg__width');
	      const hInput = this.querySelector('.pw-cg__height');
	      if (wInput) wInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this._calculate(); } });
	      if (hInput) hInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this._calculate(); } });
	      [wInput, hInput].forEach((input) => {
	        if (!input) return;
	        input.addEventListener('input', () => this._onDimensionInputChanged());
	      });

      // Modal close / confirm
      const closeBtn = this.querySelector('.pw-cg__modal-close');
      if (closeBtn) closeBtn.addEventListener('click', () => this._closeModal());

	      const confirmBtn = this.querySelector('.pw-cg__modal-confirm');
	      if (confirmBtn) confirmBtn.addEventListener('click', () => this._confirmCrop());

	      const backBtn = this.querySelector('.pw-cg__modal-back');
	      if (backBtn) backBtn.addEventListener('click', () => this._closeModal());

      // Manual size entry. In stepper mode, build our own radio-card grid
      // (Prestige's size fieldset is hidden in the variant-picker). Clicking a
      // card ticks the matching hidden Prestige radio — single write semantics,
      // Prestige's selectCombination handles variant resolution.
      if (this._stepper) {
        this._setupManualAccordion();
      } else {
        var manualSizeDetails = document.querySelector('variant-picker[form-id="' + this._formId + '"] details.pw-cg-manual-size');
        if (manualSizeDetails) {
          manualSizeDetails.addEventListener('toggle', () => {
            if (manualSizeDetails.open) this._openManualMode();
          });
        }
      }

	      // Backdrop click
      const modal = this.querySelector('.pw-cg__modal');
      if (modal) modal.addEventListener('click', (e) => { if (e.target === modal) this._closeModal(); });

      // Escape key
      if (modal) modal.addEventListener('cancel', (e) => { e.preventDefault(); this._closeModal(); });

      // Crop frame drag (pointer events handle mouse + touch)
      const frame = this.querySelector('.pw-cg__crop-frame');
      if (frame) frame.addEventListener('pointerdown', (e) => this._onPointerDown(e));
      if (frame) frame.addEventListener('keydown', (e) => this._onCropKeydown(e));

      window.addEventListener('resize', this._onWindowResize);

      // Restore state
		      this._applyMaterialDisplayLabels();
		      this._restoreState();

		      requestAnimationFrame(() => {
	        this._restoreManualSelectionFromForm();
	        this._updateInitialPriceDisplay();
	        this._updateBuyButtonState();
	      });
		    }

    _findForm() {
      if (!this._formId) return null;
      return document.getElementById(this._formId) || document.forms[this._formId] || null;
    }

    /* Manual-size accordion. Our own radio-card grid of all sizes. Clicking
       a card ticks the matching HIDDEN Prestige radio (which lives in the
       suppressed size fieldset inside the variant-picker). Prestige's
       document.body-level change delegation catches the tick, fires
       selectCombination, writes [name="id"], and dispatches variant:change.
       Single write — no double-set, no direct [name="id"] write. */
    _setupManualAccordion() {
      var stepper = this._stepper;
      var link = stepper && stepper.querySelector('[data-pw-cg-manual-link]');
      this._manualPanel = this.querySelector('[data-pw-cg-manual-panel]');
      this._sizeGrid = this.querySelector('[data-pw-cg-size-grid]');
      this._manualConfirmBtn = this.querySelector('[data-pw-cg-manual-confirm]');
      this._backToMeasureLink = this.querySelector('[data-pw-cg-back-to-measure]');
      this._manualLink = link;
      if (!link || !this._manualPanel) return;

      link.addEventListener('click', () => this._openManualPanel());
      if (this._backToMeasureLink) {
        this._backToMeasureLink.addEventListener('click', () => this._closeManualPanel());
      }
      if (this._manualConfirmBtn) {
        this._manualConfirmBtn.addEventListener('click', () => this._confirmManualSize());
      }

      this._buildSizeGrid();
    }

    /* Build our own radio-card grid from variant data. Each card shows size +
       "Fra xxx kr" (lowest price across materials for that size). Clicking a
       card ticks the matching hidden Prestige size radio. */
    _buildSizeGrid() {
      if (!this._sizeGrid || !this._variants) return;

      var sizeMap = {};
      for (var i = 0; i < this._variants.length; i++) {
        var v = this._variants[i];
        if (!v.available) continue;
        var d = this._dimsForVariant(v);
        if (!d) continue;
        var key = d.w + 'x' + d.h;
        if (!sizeMap[key] || v.price < sizeMap[key].price) {
          sizeMap[key] = { w: d.w, h: d.h, price: v.price, variant: v };
        }
      }

      var sizes = Object.values(sizeMap).sort(function(a, b) {
        return (a.w * a.h) - (b.w * b.h);
      });

      this._sizeGrid.innerHTML = '';
      var self = this;
      sizes.forEach(function(s) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'pw-cg__size-card';
        card.dataset.sizeKey = s.w + 'x' + s.h;
        card.innerHTML =
          '<span class="pw-cg__size-card-dim">' + self._formatCm(s.w) + '×' + self._formatCm(s.h) + '</span>' +
          '<span class="pw-cg__size-card-price">Fra ' + self._fmtPrice(s.price) + '</span>';
        card.addEventListener('click', function() {
          self._sizeGrid.querySelectorAll('.pw-cg__size-card--selected').forEach(function(c) { c.classList.remove('pw-cg__size-card--selected'); });
          card.classList.add('pw-cg__size-card--selected');
          // Tick the matching hidden Prestige radio — single write, no
          // direct [name="id"] write. Prestige's delegation handles the rest.
          self._tickHiddenSizeRadio(s.variant);
          if (self._manualConfirmBtn) self._manualConfirmBtn.disabled = false;
        });
        self._sizeGrid.appendChild(card);
      });
    }

    /* Find and tick the hidden Prestige size radio matching this variant's
       size option. Prestige's selectCombination then resolves the full
       variant (size + current material) and writes [name="id"]. */
    _tickHiddenSizeRadio(variant) {
      if (!variant || !variant.options) return;
      var sizeOptionPos = -1;
      for (var i = 0; i < this._optionNames.length; i++) {
        if (/st\u00f8rrelse|size/i.test(this._optionNames[i])) { sizeOptionPos = i; break; }
      }
      if (sizeOptionPos < 0) return;

      var sizeValue = variant.options[sizeOptionPos];
      var normalizedTarget = this._normalizeOptionValue(sizeValue);
      var inputs = document.querySelectorAll('input[data-option-position="' + (sizeOptionPos + 1) + '"][form="' + this._formId + '"]');

      for (var j = 0; j < inputs.length; j++) {
        var input = inputs[j];
        var label = input.closest('label') || (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null);
        var labelValue = this._normalizeOptionValue(input.dataset.optionValueName || (label ? label.textContent : ''));
        if (labelValue === normalizedTarget) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
    }

    _openManualPanel() {
      this._manualPanel.hidden = false;
      this._manualLink.hidden = true;
      this.classList.add('pw-cg--manual-active');
      this._manualMode = true;
      this._manualConfirmed = false;
      this._assistedActive = false;
      this._cropConfirmed = false;
      this._recommendedVariant = null;
      this._removeFormProperties();
      this._resetMainPriceDisplay();
      // Clear our own card visual state (spec: no preselect)
      if (this._sizeGrid) this._sizeGrid.querySelectorAll('.pw-cg__size-card--selected').forEach(c => c.classList.remove('pw-cg__size-card--selected'));
      if (this._manualConfirmBtn) this._manualConfirmBtn.disabled = true;
      this._updateConfirmationUI();
      this._syncStage();
      this._event('manual_panel_opened', {});
    }

    _closeManualPanel() {
      this._manualPanel.hidden = true;
      this._manualLink.hidden = false;
      this.classList.remove('pw-cg--manual-active');
      if (this._sizeGrid) this._sizeGrid.querySelectorAll('.pw-cg__size-card--selected').forEach(c => c.classList.remove('pw-cg__size-card--selected'));
      if (this._manualConfirmBtn) this._manualConfirmBtn.disabled = true;
      this._manualMode = false;
      this._manualConfirmed = false;
      this._removeFormProperties();
      this._resetMainPriceDisplay();
      this._updateConfirmationUI();
      this._syncStage();
      this._event('manual_panel_closed', {});
    }

    _confirmManualSize() {
      // Pure observer: reads the variant from the form (set by Prestige
      // when the user clicked a size radio). No writes to [name="id"],
      // no _selectVariantOptions, no setTimeout.
      var variantId = this._currentVariantId();
      if (!variantId) return;
      var v = this._variants.find(function(vx) { return vx.id === Number(variantId); });
      if (!v) return;

      this._manualConfirmed = true;
      this._manualMode = false;
      this._assistedActive = false;
      this._cropConfirmed = false;
      this._recommendedVariant = null;

      // Absorb writes that used to live in _enterManualMode
      this._updateManualFormProperties(v);
      this._updateMainPriceDisplay(v);
      this._manualPanel.hidden = true;
      this._manualLink.hidden = true;
      this.classList.remove('pw-cg--manual-active');
      this._updateConfirmationUI();
      this._syncStage();

      // Hide crop button in manual mode (spec: no crop in manual flow)
      var stepRecommend = this._stepper && this._stepper.querySelector('[data-pw-cg-step="recommend"]');
      var cropBtn = stepRecommend && stepRecommend.querySelector('[data-pw-cg-open-crop]');
      if (cropBtn) cropBtn.style.display = 'none';

      // Focus management: move focus to step 2's first material radio
      var step2 = this._stepper && this._stepper.querySelector('[data-pw-cg-step="recommend"]');
      var focusTarget = step2 && step2.querySelector('.block-swatch');
      if (focusTarget) focusTarget.focus({ preventScroll: false });

      this._event('manual_size_confirmed', { variant_id: v.id });
      this._saveState();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onWindowResize);
      document.removeEventListener('pointermove', this._onPointerMove);
      document.removeEventListener('pointerup', this._onPointerUp);
    }

    /* ------------------------------------------------------------------ */
    /*  Variant dimension parsing                                          */
    /* ------------------------------------------------------------------ */

    _parseDimsFromText(text) {
      if (!text) return null;
      var m = String(text).match(/(\d+(?:[,.]\d+)?)\s*(?:cm)?\s*[xX\u00d7]\s*(\d+(?:[,.]\d+)?)\s*(?:cm)?/);
      if (!m) return null;
      var w = parseFloat(String(m[1]).replace(',', '.'));
      var h = parseFloat(String(m[2]).replace(',', '.'));
      return w > 0 && h > 0 ? { w: w, h: h } : null;
    }

    _formatCm(value) {
      var n = Number(value);
      if (!Number.isFinite(n)) return '';
      var rounded = Math.round(n * 10) / 10;
      if (Math.abs(rounded - Math.round(rounded)) < 0.0001) return String(Math.round(rounded));
      return rounded.toFixed(1).replace('.', ',');
    }

    _formatDims(dims) {
      if (!dims) return '';
      return this._formatCm(dims.w) + ' x ' + this._formatCm(dims.h) + ' cm';
    }

    _dimsForVariant(variant) {
      if (!variant) return null;

      if (variant.options && this._optionNames) {
        for (var i = 0; i < variant.options.length; i++) {
          var optionName = this._optionNames[i] || '';
          var optionValue = variant.options[i] || '';
          if (/st\u00f8rrelse|size|bredde|h\u00f8jde/i.test(optionName)) {
            var fromNamedOption = this._parseDimsFromText(optionValue);
            if (fromNamedOption) return fromNamedOption;
          }
        }

        for (var j = 0; j < variant.options.length; j++) {
          var fromAnyOption = this._parseDimsFromText(variant.options[j]);
          if (fromAnyOption) return fromAnyOption;
        }
      }

      return this._parseDimsFromText(variant.title);
    }

    /* ------------------------------------------------------------------ */
    /*  Recommendation algorithm                                           */
    /* ------------------------------------------------------------------ */

    _recommend(ww, wh, preferredMaterial) {
      // Consalnet (supplier) recommends adding 5 cm margin to the wall width and height
      // to absorb uneven walls, ceilings, and floors. The buffer is added here only for
      // picking the smallest standard size; trim math still uses the actual entered wall.
      var bufferCm = 5;
      var requiredW = ww + bufferCm;
      var requiredH = wh + bufferCm;
      var list = [];
      for (var i = 0; i < this._variants.length; i++) {
        var v = this._variants[i];
        if (!v.available) continue;
        if (preferredMaterial && this._normalizeOptionValue(this._materialForVariant(v)) !== this._normalizeOptionValue(preferredMaterial)) continue;
        var d = this._dimsForVariant(v);
        if (!d) continue;
        if (d.w < requiredW || d.h < requiredH) continue; // too small (with 5 cm Consalnet buffer)
        list.push({ v: v, d: d, area: d.w * d.h, price: v.price, wSurplus: d.w - ww, order: i });
      }
      if (!list.length) return null;
      list.sort(function (a, b) {
        if (a.area !== b.area) return a.area - b.area;
        if (a.price !== b.price) return a.price - b.price;
        if (a.wSurplus !== b.wSurplus) return a.wSurplus - b.wSurplus;
        return a.order - b.order;
      });
      return list[0];
    }

    /* ------------------------------------------------------------------ */
    /*  Calculator                                                         */
    /* ------------------------------------------------------------------ */

	    _calculate() {
	      this._trackCalculatorOpened();

      var wInput = this.querySelector('.pw-cg__width');
      var hInput = this.querySelector('.pw-cg__height');
      var ww = parseInt(wInput && wInput.value, 10);
      var wh = parseInt(hInput && hInput.value, 10);

      if (!ww || !wh || ww <= 0 || wh <= 0) {
	        this._assistedActive = false;
	        this._cropConfirmed = false;
	        this._manualMode = false;
	        this._manualConfirmed = false;
	        this._recommendedVariant = null;
	        this._showMsg('error', 'Indtast venligst gyldige m\u00e5l i cm.');
	        this._updateConfirmationUI();
        this._removeFormProperties();
        this._resetMainPriceDisplay();
        this._saveState();
        return;
      }

	      this._wallWidth = ww;
	      this._wallHeight = wh;
	      this._assistedActive = true;
	      this._cropConfirmed = false;
	      this._manualMode = false;
	      this._manualConfirmed = false;
	      this._clearManualSizeSummary();
	      if (this._manualPanel) this._closeManualPanel();

      this._event('dimensions_entered', { wall_width_cm: ww, wall_height_cm: wh });

      var selectedMaterial = this._selectedMaterial();
      var res = this._recommend(ww, wh, selectedMaterial);
      if (!res) {
        this._showMsg('no-fit');
        this._event('no_fit', { wall_width_cm: ww, wall_height_cm: wh, no_fit_reason: 'wall_larger_than_available_variants' });
	        this._assistedActive = false;
	        this._manualMode = false;
	        this._updateConfirmationUI();
        this._removeFormProperties();
        this._resetMainPriceDisplay();
        this._saveState();
        return;
      }

      this._recommendedVariant = res.v;

      // Default crop: centred
      this._cropX = Math.round((res.d.w - ww) / 2);
      this._cropY = Math.round((res.d.h - wh) / 2);

      this._saveState();
      // Single write: tick the hidden Prestige radios. Prestige's
      // selectCombination resolves the variant + writes [name="id"].
      this._selectVariantOptions(res.v);

	      this._showMsg('recommendation', res);
	      this._setCalculationCtaState(true);
	      this._event('recommendation', {
        variant_id: res.v.id,
        standard_width_cm: res.d.w,
        standard_height_cm: res.d.h,
        wall_width_cm: ww,
        wall_height_cm: wh,
      });

	      this._updateConfirmationUI();
	      this._saveState();
	    }

		    _onDimensionInputChanged() {
		      if (!this._assistedActive && !this._recommendedVariant) return;
	      this._assistedActive = false;
	      this._cropConfirmed = false;
	      this._recommendedVariant = null;
	      this._clearManualSizeSummary();
	      this._removeFormProperties();
	      this._resetMainPriceDisplay();
	      this._setCalculationCtaState(false);
	      this._updateConfirmationUI();
		      this._saveState();
		    }

	    _enterManualMode(variant) {
	      // UI/state-only. Form-property writes, price display, and analytics
	      // fire from _confirmManualSize on the explicit "Brug denne størrelse"
	      // click, not here. This method is called from the variant:change
	      // listener when an assisted flow user changes material/variant in a
	      // way that doesn't match the recommendation (assisted→manual switch).
	      this._cropConfirmed = false;
	      this._assistedActive = false;
	      this._manualMode = true;
	      this._manualConfirmed = false;
	      this._recommendedVariant = null;

	      this._clearRecommendation();
	      this._setCalculationCtaState(false);
	      this._removeFormProperties();
	      this._resetMainPriceDisplay();

	      this._updateConfirmationUI();
	      this._saveState();
	    }

		    _retToSizeStep() {
	      this._resetFlow();
	      var wInput = this.querySelector('.pw-cg__width');
	      if (wInput) wInput.focus({ preventScroll: false });
	      this._event('ret_to_size_step', {});
	    }

	    _retToRecommendStep() {
	      this._cropConfirmed = false;
	      this._manualMode = false;
	      this._manualConfirmed = false;
	
	      this._removeFormProperties();
	      this._updateConfirmationUI();
	      this._saveState();
	      var step2 = this._stepper && this._stepper.querySelector('[data-pw-cg-step="recommend"]');
	      var focusTarget = step2 && (step2.querySelector('[data-pw-cg-open-crop]') || step2.querySelector('.block-swatch'));
	      if (focusTarget) focusTarget.focus({ preventScroll: false });
	      this._event('ret_to_recommend_step', {});
	    }

	    _resetFlow() {
	      this._wallWidth = 0;
	      this._wallHeight = 0;
	      this._recommendedVariant = null;
	      this._cropX = 0;
	      this._cropY = 0;
	      this._cropConfirmed = false;
	      this._assistedActive = false;
	      this._manualMode = false;
	      this._manualConfirmed = false;
	      this._standardWidth = 0;
	      this._standardHeight = 0;
	      this._trimLeft = 0;
	      this._trimRight = 0;
	      this._trimTop = 0;
	      this._trimBottom = 0;

	      var wInput = this.querySelector('.pw-cg__width');
	      var hInput = this.querySelector('.pw-cg__height');
	      if (wInput) wInput.value = '';
	      if (hInput) hInput.value = '';
	      if (this._manualPanel) this._closeManualPanel();

	      var manualSize = document.querySelector('variant-picker[form-id="' + this._formId + '"] details.pw-cg-manual-size');
	      if (manualSize) manualSize.open = false;
	      this._clearManualSizeSummary();

	      this._clearRecommendation();
	      this._removeFormProperties();
	      if (this._initialVariantId) {
	        var initialVariant = this._variants.find((v) => v.id === Number(this._initialVariantId));
	        if (initialVariant) {
	          this._selectVariantOptions(initialVariant);
	        }
	      }
	      this._clearManualSizeSummary();
	      this._resetMainPriceDisplay();
	      this._setCalculationCtaState(false);
	      this._updateConfirmationUI();
	      try { sessionStorage.removeItem(this._storageKey()); } catch (_) { /* ignore */ }
	      this._event('reset', {});
	    }

	    _restoreManualSelectionFromForm(fallbackVariant) {
	      if (!this._form) return false;

	      var hasManualProperty = !!this._form.querySelector('[name="properties[_manual_size_confirmed]"][value="true"]');
	      if (!hasManualProperty && !this._manualConfirmed) return false;

	      var selectedVariant = fallbackVariant || this._currentVariant();
	      if (!selectedVariant) return false;

	      this._cropConfirmed = false;
	      this._assistedActive = false;
	      this._manualMode = true;
	      this._manualConfirmed = true;
	      this._recommendedVariant = null;
	

	      this._clearRecommendation();
	      this._setCalculationCtaState(false);
	      this._selectVariantOptions(selectedVariant);
	      this._updateManualSizeSummary(selectedVariant, true);
	      this._updateManualFormProperties(selectedVariant);
	      this._updateMainPriceDisplay(selectedVariant);
	      this._updateConfirmationUI();
	      return true;
	    }

	    _openManualMode() {
	      this._manualMode = true;
	      this._manualConfirmed = false;
	      this._cropConfirmed = false;
	      this._assistedActive = false;
	      this._recommendedVariant = null;
	      this._clearManualSizeSummary();
	      this._clearRecommendation();
	      this._removeFormProperties();
	      this._resetMainPriceDisplay();
	
	      this._setCalculationCtaState(false);
	      this._updateConfirmationUI();
	      this._saveState();
	    }

		    _setCalculationCtaState(hasCalculation) {
		      var button = this.querySelector('.pw-cg__calc-btn');
		      if (!button) return;
		      button.textContent = hasCalculation ? 'Beregn igen' : 'Beregn st\u00f8rrelse og pris';
		      button.classList.toggle('pw-cg__calc-btn--secondary', !!hasCalculation);
		    }

	    _syncStage() {
	      var stage = 'init';
	      if (this._assistedActive && this._cropConfirmed) {
	        stage = 'crop-confirmed';
	      } else if (this._assistedActive && this._recommendedVariant) {
	        stage = 'size-entered';
      } else if (this._manualConfirmed) {
        stage = 'manual-confirmed';
      }
	      if (stage === this._stage) return;
	      this._stage = stage;
	      this.setAttribute('data-pw-cg-stage', stage);
	      if (this._stepper) {
	        this._stepper.setAttribute('data-pw-cg-stage', stage);
	        this._renderStepper();
	      }
	    }

    _renderStepper() {
      if (!this._stepper) return;
	      var stepSize = this._stepper.querySelector('[data-pw-cg-step="size"]');
	      var stepRecommend = this._stepper.querySelector('[data-pw-cg-step="recommend"]');
	      var stepBuy = this._stepper.querySelector('[data-pw-cg-step="buy"]');
	      if (!stepSize || !stepRecommend || !stepBuy) return;

	      this._setStepState(stepSize, this._stage === 'init' || this._stage === 'manual-confirmed' ? 'active' : 'done');
	      this._setStepState(stepRecommend, this._stage === 'init' ? 'locked' : ((this._stage === 'size-entered' || this._stage === 'manual-confirmed') ? 'active' : 'done'));
	      this._setStepState(stepBuy, (this._stage === 'crop-confirmed' || this._stage === 'manual-confirmed') ? 'active' : 'locked');

	      if (this._stage === 'init') {
	        this._setStepSummaryVisible(stepSize, false);
	        this._setStepBodyVisible(stepSize, true, true);
	        this._setStepSummaryVisible(stepRecommend, false);
	        this._setStepBodyVisible(stepRecommend, false, false);
	        this._setStepSummaryVisible(stepBuy, false);
	        this._setStepBodyVisible(stepBuy, false, false);
	      } else if (this._stage === 'size-entered') {
	        this._setStepSummaryVisible(stepSize, true);
	        this._setStepSizeSummary();
	        this._setStepBodyVisible(stepRecommend, true, false);
	        this._setStepSummaryVisible(stepRecommend, false);
	        this._setStepRecommendContent();
	        this._setStepSummaryVisible(stepBuy, false);
	        this._setStepBodyVisible(stepBuy, false, false);
	      } else if (this._stage === 'manual-confirmed') {
	        // Manual confirmed: step 1 done (shows size summary), step 2 active
	        // (material selection, NO crop button), step 3 active (buy).
	        this._setStepSummaryVisible(stepSize, true);
	        this._setStepSizeSummary();
	        this._setStepBodyVisible(stepSize, false, true);
	        this._setStepBodyVisible(stepRecommend, true, false);
	        this._setStepSummaryVisible(stepRecommend, false);
	        this._setStepRecommendContent();
	        // Hide the crop button in manual mode — no wall dims to crop
	        var cropBtn = stepRecommend.querySelector('[data-pw-cg-open-crop]');
	        if (cropBtn) cropBtn.style.display = 'none';
	        this._setStepBodyVisible(stepBuy, true, false);
	        this._setStepSummaryVisible(stepBuy, false);
	        this._setStepBuyContent();
      } else { // crop-confirmed
        this._setStepSummaryVisible(stepSize, true);
        this._setStepSizeSummary();
        this._setStepSummaryVisible(stepRecommend, true);
        this._setStepRecommendSummary();
        this._setStepBodyVisible(stepRecommend, false, false);
        // Restore the crop button visibility (was hidden in manual mode)
        var cropBtnRestore = stepRecommend.querySelector('[data-pw-cg-open-crop]');
        if (cropBtnRestore) cropBtnRestore.style.display = '';
        this._setStepBodyVisible(stepBuy, true, false);
        this._setStepSummaryVisible(stepBuy, false);
	        this._setStepBuyContent();
	      }

	      this._toggleTrustRow();
	    }

	    _toggleTrustRow() {
	      var row = this._photoStepperRoot() && this._photoStepperRoot().querySelector('[data-pw-cg-trust-row]');
	      if (!row) return;
	      row.hidden = this._stage !== 'crop-confirmed';
	    }

	    _photoStepperRoot() {
	      if (!this._form) return null;
	      return this._form.closest('.nt-photo-product') || this._form.closest('.product-info') || null;
	    }

	    _setStepState(stepEl, state) {
	      if (!stepEl) return;
	      stepEl.classList.remove('nt-photo-step--active', 'nt-photo-step--done', 'nt-photo-step--locked');
	      stepEl.classList.add('nt-photo-step--' + state);
	      if (state === 'active') {
	        stepEl.setAttribute('aria-current', 'step');
	      } else {
	        stepEl.removeAttribute('aria-current');
	      }
	    }

	    _setStepBodyVisible(stepEl, visible, isSizeStep) {
	      if (!stepEl) return;
	      var body = stepEl.querySelector('.nt-photo-step__body');
	      if (body) {
	        if (isSizeStep) {
	          body.hidden = false;
	        } else {
	          body.hidden = !visible;
	        }
	      }
	      var lockedMsg = stepEl.querySelector('.nt-photo-step__locked-msg');
	      if (lockedMsg) lockedMsg.hidden = visible;
	    }

    _setStepSummaryVisible(stepEl, visible) {
      if (!stepEl) return;
      var summary = stepEl.querySelector('.nt-photo-step__summary');
      if (summary) summary.hidden = !visible;
      var ret = stepEl.querySelector('.nt-photo-step__ret');
      if (ret) ret.hidden = !visible;
    }

	    _setStepSizeSummary() {
	      var stepEl = this._stepper.querySelector('[data-pw-cg-step="size"]');
	      if (!stepEl) return;
	      var value = stepEl.querySelector('[data-pw-cg-step-summary-value]');
	      var label = stepEl.querySelector('[data-pw-cg-step-summary-label]');
	      if (!value) return;
	      if (this._manualConfirmed) {
	        var mv = this._variants.find((vx) => vx.id === this._currentVariantId());
	        var d = mv ? this._dimsForVariant(mv) : null;
	        value.textContent = d ? (this._formatCm(d.w) + ' \u00d7 ' + this._formatCm(d.h) + ' cm') : '';
	        if (label) label.textContent = '✓ Størrelse';
	      } else {
	        value.textContent = this._wallWidth + ' \u00d7 ' + this._wallHeight + ' cm';
	        if (label) label.textContent = '✓ Væg';
	      }
	    }

	    _setStepRecommendContent() {
      var isManual = this._manualConfirmed;
      var variant = isManual ? (this._variants.find((vx) => vx.id === this._currentVariantId()) || null) : this._recommendedVariant;
	      if (!variant) return;
	      var d = this._dimsForVariant(variant);
	      var eyebrowEl = this._stepper.querySelector('[data-pw-cg-recommend-card] .nt-photo-step__recommend-eyebrow');
	      var sizeEl = this._stepper.querySelector('[data-pw-cg-recommend-size]');
	      var wallEl = this._stepper.querySelector('[data-pw-cg-recommend-wall]');
	      var priceEl = this._stepper.querySelector('[data-pw-cg-recommend-price]');
	      if (eyebrowEl) eyebrowEl.textContent = isManual ? 'Valgt størrelse' : 'Vi anbefaler';
	      if (sizeEl && d) sizeEl.textContent = this._formatCm(d.w) + ' \u00d7 ' + this._formatCm(d.h) + ' cm';
	      if (wallEl) {
	        if (isManual) {
	          wallEl.style.display = 'none';
	        } else {
	          wallEl.style.display = '';
	          wallEl.textContent = this._wallWidth + ' \u00d7 ' + this._wallHeight + ' cm';
	        }
	      }
	      if (priceEl) {
	        var pricePerM2 = this._computeVariantPricePerM2(variant);
	        var pricePerM2Display = pricePerM2 ? ' (' + this._fmtPricePerM2(pricePerM2) + ')' : '';
	        priceEl.innerHTML = '<strong>Totalpris: ' + this._fmtPrice(variant.price) + pricePerM2Display + '</strong>';
	      }
	    }

	    _setStepRecommendSummary() {
	      if (!this._recommendedVariant && !this._manualConfirmed) return;
	      var variant = this._recommendedVariant || this._currentVariant();
	      if (!variant) return;
	      var stepEl = this._stepper.querySelector('[data-pw-cg-step="recommend"]');
	      if (!stepEl) return;
	      var value = stepEl.querySelector('[data-pw-cg-step-summary-value]');
	      var d = this._dimsForVariant(variant);
	      var mat = this._displayMaterial(this._materialForVariant(variant));
	      if (!value || !d) return;
	      value.textContent = this._formatCm(d.w) + ' \u00d7 ' + this._formatCm(d.h) + ' cm' + (mat ? ' \u00b7 ' + mat : '');
	    }

	    _setStepBuyContent() {
	      var variant = this._recommendedVariant || this._currentVariant();
	      if (!variant) return;
	      var d = this._dimsForVariant(variant);
	      var sizeEl = this._stepper.querySelector('[data-pw-cg-buy-size]');
	      var matEl = this._stepper.querySelector('[data-pw-cg-buy-material]');
	      var priceEl = this._stepper.querySelector('[data-pw-cg-buy-price]');
	      var trimEl = this._stepper.querySelector('[data-pw-cg-buy-trim]');
	      if (sizeEl && d) sizeEl.textContent = this._formatCm(d.w) + ' \u00d7 ' + this._formatCm(d.h) + ' cm';
	      if (matEl) matEl.textContent = this._displayMaterial(this._materialForVariant(variant)) || this._materialForVariant(variant) || '';
	      if (priceEl) {
	        var pricePerM2 = this._computeVariantPricePerM2(variant);
	        var pricePerM2Display = pricePerM2 ? ' (' + this._fmtPricePerM2(pricePerM2) + ')' : '';
	        priceEl.textContent = this._fmtPrice(variant.price) + pricePerM2Display;
	      }
	      if (trimEl) {
	        if (this._trimLeft || this._trimRight || this._trimTop || this._trimBottom) {
	          trimEl.textContent = 'Du skal sk\u00e6re ' + this._trimLeft + ' cm venstre, ' + this._trimRight + ' cm h\u00f8jre, ' + this._trimTop + ' cm top, ' + this._trimBottom + ' cm bund efter ops\u00e6tning.';
	        } else if (d && (d.w > this._wallWidth || d.h > this._wallHeight)) {
	          trimEl.textContent = 'Tapetet leveres i standardst\u00f8rrelsen. Overskydende tapet sk\u00e6res v\u00e6k langs kanterne efter ops\u00e6tning.';
	        } else {
	          trimEl.textContent = 'Standardst\u00f8rrelsen passer pr\u00e6cist til din v\u00e6g.';
	        }
	      }
	    }

	    /* ------------------------------------------------------------------ */
	    /*  UI messages                                                        */
	    /* ------------------------------------------------------------------ */

	    _clearRecommendation() {
	      var el = this.querySelector('.pw-cg__result');
	      if (!el) return;
	      el.classList.remove('pw-cg__result--visible');
	      el.innerHTML = '';
	    }

	    _showMsg(type, data) {
      var el = this.querySelector('.pw-cg__result');
      if (!el) return;
      el.classList.add('pw-cg__result--visible');

      if (type === 'error') {
        el.innerHTML = '<p class="pw-cg__error">' + data + '</p>';
        return;
      }

	      if (type === 'no-fit') {
	        this._setCalculationCtaState(false);
	        el.innerHTML =
          '<div class="pw-cg__card pw-cg__card--warn">' +
          '<p class="pw-cg__card-title">Denne fototapet f\u00e5s desv\u00e6rre ikke stor nok til dine m\u00e5l.</p>' +
          '<p>Du kan <a href="/pages/kontakt" class="pw-cg__link">kontakte os</a> for r\u00e5dgivning, eller v\u00e6lge en standardst\u00f8rrelse manuelt.</p>' +
          '</div>';
        return;
      }

      if (type === 'recommendation' && data) {
	        var variantPrice = this._fmtPrice(data.v.price);
	        var pricePerM2 = this._computeVariantPricePerM2(data.v);
	        var pricePerM2Display = pricePerM2 ? this._fmtPricePerM2(pricePerM2) : '';
        var pricePerM2Inline = pricePerM2Display ? ' (' + pricePerM2Display + ')' : '';
        var size = this._formatCm(data.d.w) + ' \u00d7 ' + this._formatCm(data.d.h) + ' cm';
        var wallSize = this._wallWidth + ' \u00d7 ' + this._wallHeight + ' cm';
        var material = this._displayMaterial(this._materialForVariant(data.v));
        el.innerHTML =
          '<div class="pw-cg__card">' +
          '<p class="pw-cg__card-kicker">Vi anbefaler</p>' +
          '<div class="pw-cg__recommendation">' +
          '<div><span>Din v\u00e6g</span><strong>' + wallSize + '</strong></div>' +
          '<div><span>Standardst\u00f8rrelse</span><strong>' + size + '</strong></div>' +
          '</div>' +
          (material ? '<p class="pw-cg__card-material">Materiale: <strong>' + material + '</strong></p>' : '') +
	          '<p class="pw-cg__card-price">Totalpris: ' + variantPrice + pricePerM2Inline + '</p>' +
	          '<p class="pw-cg__card-next">St\u00f8rrelsen er valgt automatisk. Vi har lagt 5 cm til h\u00f8jden og bredden for uj\u00e6vnheder i v\u00e6ggen.</p>' +
	          '<p class="pw-cg__card-info">Tapetet leveres lidt st\u00f8rre end din v\u00e6g. Overskydende tapet sk\u00e6res v\u00e6k ved ops\u00e6tning.</p>' +
	          '<button type="button" class="pw-cg__open-crop-btn button w-full">Kontroll\u00e9r besk\u00e6ring</button>' +
	          '</div>';
        var btn = el.querySelector('.pw-cg__open-crop-btn');
        if (btn) btn.addEventListener('click', () => this._openModal());

        this._updateMainPriceDisplay(data.v);
      }
    }

    _fmtPrice(cents) {
      var amount = (cents / 100).toFixed(2);
      if (amount.endsWith('.00')) amount = amount.slice(0, -3);
      amount = amount.replace('.', ',');
      return amount + ' kr.';
    }

    _fmtPricePerM2(pricePerM2Cents) {
      var amount = (pricePerM2Cents / 100).toFixed(0);
      return amount + ' kr./m\u00b2';
    }

    _computeVariantPricePerM2(variant) {
      var dims = this._dimsForVariant(variant);
      if (!dims) return null;
      var areaM2 = (dims.w * dims.h) / 10000;
      return variant.price / areaM2;
    }

	    _computeLowestTotalPrice(material) {
	      var best = null;
	      for (var i = 0; i < this._variants.length; i++) {
	        var v = this._variants[i];
        if (!v.available) continue;
        if (material) {
          var mat = this._materialForVariant(v);
          if (!mat || this._normalizeOptionValue(mat) !== this._normalizeOptionValue(material)) continue;
        }
	        if (!best || v.price < best.price) best = { price: v.price, variant: v };
	      }
	      return best;
	    }

	    _updateMainPriceDisplay(variant) {
	      if (!variant) return;
      var pricePerM2 = this._computeVariantPricePerM2(variant);
      var pricePerM2Display = pricePerM2 ? ' (' + this._fmtPricePerM2(pricePerM2) + ')' : '';
	      this._productPriceElements().forEach((salePrice) => {
	        if (!salePrice.dataset.pwCgOriginalHtml) {
	          salePrice.dataset.pwCgOriginalHtml = salePrice.innerHTML;
	        }

	        var srOnly = salePrice.querySelector('.sr-only');
	        var srHtml = srOnly ? srOnly.outerHTML : '';
	        salePrice.innerHTML = srHtml + 'Totalpris: ' + this._fmtPrice(variant.price) + pricePerM2Display;
	      });
	    }

    _updateInitialPriceDisplay() {
	      if (this._assistedActive || this._manualConfirmed) return;

      var material = this._selectedMaterial();
      if (!material) material = 'Premium Papirstapet';

	      var best = this._computeLowestTotalPrice(material);
	      if (!best) return;

	      this._productPriceElements().forEach((salePrice) => {
	        if (!salePrice.dataset.pwCgOriginalHtml) {
	          salePrice.dataset.pwCgOriginalHtml = salePrice.innerHTML;
	        }

	        var srOnly = salePrice.querySelector('.sr-only');
	        var srHtml = srOnly ? srOnly.outerHTML : '';
	        salePrice.innerHTML = srHtml + 'Fra ' + this._fmtPrice(best.price);
	      });
	    }

    _resetMainPriceDisplay() {
      this._updateInitialPriceDisplay();
    }

    _productPriceElements() {
      var elements = [];
      var container = this.closest('.product-info') || this.parentElement;
      if (container) elements = elements.concat(Array.from(container.querySelectorAll('sale-price')));

      if (this._formId) {
        elements = elements.concat(Array.from(document.querySelectorAll('product-sticky-bar[form="' + this._formId + '"] sale-price, .product-sticky-bar[form="' + this._formId + '"] sale-price')));
      }

      return elements.filter((element, index, list) => element && list.indexOf(element) === index);
    }

    /* ------------------------------------------------------------------ */
    /*  Form variant                                                       */
    /* ------------------------------------------------------------------ */

    _selectVariantOptions(variant) {
      if (!variant || !variant.options) return;

      // Use document.querySelectorAll, not picker.querySelectorAll — the size
      // radios have been relocated out of variant-picker into the step-1 slot.
      // The form="..." attribute already scopes the query correctly regardless
      // of where the input lives in the DOM.

      for (var i = 0; i < variant.options.length; i++) {
        var optionValue = this._normalizeOptionValue(variant.options[i]);
        var inputs = document.querySelectorAll('input[data-option-position="' + (i + 1) + '"][form="' + this._formId + '"]');

        for (var j = 0; j < inputs.length; j++) {
          var input = inputs[j];
          var label = input.closest('label') || (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null);
          var labelValue = this._normalizeOptionValue(input.dataset.optionValueName || (label ? label.textContent : ''));

          if (labelValue === optionValue) {
            if (!input.checked) {
              input.checked = true;
              // Dispatch `change` so Prestige's variant-picker delegation
              // catches it, fires `selectCombination`, writes [name="id"],
              // and dispatches `variant:change`. Without this, the form's
              // hidden [name="id"] input stays on the default variant and
              // the wrong size ends up in the cart.
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            break;
          }
        }
      }

      this._updateManualSizeSummary(variant, this._manualConfirmed);
    }

    _clearManualSizeSummary() {
      var picker = document.querySelector('variant-picker[form-id="' + this._formId + '"]');
      var manualSize = picker && picker.querySelector('details.pw-cg-manual-size');
      var selectedText = manualSize && manualSize.querySelector('[data-pw-cg-manual-selected]');
      if (!selectedText) return;
      selectedText.textContent = '';
      selectedText.hidden = true;
    }

    _updateManualSizeSummary(variant, showCustomerSummary) {
      if (!variant || !variant.options || !this._optionNames) {
        this._clearManualSizeSummary();
        return;
      }

      for (var i = 0; i < this._optionNames.length; i++) {
        if (!/st\u00f8rrelse/i.test(this._optionNames[i])) continue;

        var picker = document.querySelector('variant-picker[form-id="' + this._formId + '"]');
        var manualSize = picker && picker.querySelector('details.pw-cg-manual-size');
        var selectedText = manualSize && manualSize.querySelector('[data-pw-cg-manual-selected]');
        var dims = this._dimsForVariant(variant);
        var summaryLabel = dims ? this._formatDims(dims) : (variant.options[i] || '');
        if (selectedText) {
          selectedText.textContent = showCustomerSummary && summaryLabel ? summaryLabel : '';
          selectedText.hidden = !(showCustomerSummary && summaryLabel);
        }

        var selectedValue = manualSize && manualSize.querySelector('[id$="-selected-value"]');
        if (selectedValue) selectedValue.textContent = variant.options[i] || '';
        break;
      }
    }

    _normalizeOptionValue(value) {
      return String(value || '').toLowerCase().replace(/\s+/g, '').replace(/\u00d7/g, 'x');
    }

    _currentVariantId() {
      if (!this._form) return null;
      var inp = this._form.querySelector('[name="id"]');
      return inp && inp.value ? parseInt(inp.value, 10) : null;
    }

    _selectedMaterial() {
      // Use document.querySelector, not picker-scope — radios may be relocated.
      for (var i = 0; i < this._optionNames.length; i++) {
        if (!/materiale/i.test(this._optionNames[i])) continue;
        var checked = document.querySelector('input[data-option-position="' + (i + 1) + '"][form="' + this._formId + '"]:checked');
        if (!checked) break;
        var label = checked.closest('label') || (checked.nextElementSibling && checked.nextElementSibling.tagName === 'LABEL' ? checked.nextElementSibling : null);
        return checked.dataset.optionValueName || (label ? label.textContent.trim() : checked.value);
      }

      return this._materialForVariant(this._variants.find((v) => v.id === this._currentVariantId()));
    }

    _applyMaterialDisplayLabels() {
      if (!this._optionNames) return;

      for (var i = 0; i < this._optionNames.length; i++) {
        if (!/materiale/i.test(this._optionNames[i])) continue;

        // Use document scope — material radios may not always be inside variant-picker
        var inputs = document.querySelectorAll('input[data-option-position="' + (i + 1) + '"][form="' + this._formId + '"]');
        inputs.forEach((input) => {
          var label = input.closest('label') || (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null);
          if (!label) return;

          var originalMaterial = input.dataset.optionValueName || label.textContent.trim();
          if (!originalMaterial) return;

          input.dataset.optionValueName = originalMaterial;

          var textTarget = label.querySelector('span:last-child') || label;
          textTarget.textContent = this._displayMaterial(originalMaterial);
        });
        break;
      }
    }

    _syncRecommendationAfterMaterialChange(variant) {
      if (!variant || !this._recommendedVariant || !this._wallWidth || !this._wallHeight) return false;

      var oldDims = this._dimsForVariant(this._recommendedVariant);
      var newDims = this._dimsForVariant(variant);
      if (!oldDims || !newDims) return false;

      // Material changes produce a new variant ID while keeping the recommended
      // wall-covering size. Treat that as assisted-flow continuity, not manual size selection.
      if (oldDims.w !== newDims.w || oldDims.h !== newDims.h) return false;
      if (newDims.w < this._wallWidth || newDims.h < this._wallHeight) return false;

      this._recommendedVariant = variant;
      // Preserve crop-confirmed state — material change in step 3 should not
      // collapse the step back. Only reset manual-mode flags.
      this._manualMode = false;
      this._manualConfirmed = false;

      this._removeFormProperties();
      this._updateManualSizeSummary(variant, false);
      // Prestige already wrote [name="id"] via selectCombination (user clicked
      // material radio). Just update _recommendedVariant + UI.
      this._updateMainPriceDisplay(variant);
      this._showMsg('recommendation', { v: variant, d: newDims });
      this._setCalculationCtaState(true);
      this._updateConfirmationUI();
      // Refresh step-2 recommend card + step-3 buy card so Totalpris updates
      this._setStepRecommendContent();
      this._setStepBuyContent();
      this._saveState();
      this._event('material_changed_after_recommendation', this._eventPayload());
      return true;
    }

    _materialForVariant(variant) {
      if (!variant || !variant.options || !this._optionNames) return null;
      for (var i = 0; i < this._optionNames.length; i++) {
        if (/materiale/i.test(this._optionNames[i])) return variant.options[i] || null;
      }
      return null;
    }

    _displayMaterial(material) {
      if (!material) return '';
      return /vinyl/i.test(material) ? 'Ekstra slidst\u00e6rkt fototapet' : 'Standard fototapet';
    }

    /* ------------------------------------------------------------------ */
    /*  Form line-item properties                                          */
    /* ------------------------------------------------------------------ */

    _updateFormProperties() {
      this._removeFormProperties();
      if (!this._assistedActive || !this._cropConfirmed || !this._form) return;
      if (!this._recommendedVariant) return;
      var d = this._dimsForVariant(this._recommendedVariant);
      if (!d) return;

      var props = [
        ['V\u00e6ggens bredde', this._wallWidth + ' cm'],
        ['V\u00e6ggens h\u00f8jde', this._wallHeight + ' cm'],
        ['Anbefalet standardst\u00f8rrelse', this._formatDims(d)],
        ['Materiale', this._displayMaterial(this._materialForVariant(this._recommendedVariant)) || this._materialForVariant(this._recommendedVariant) || ''],
        ['Besk\u00e6ring venstre', this._trimLeft + ' cm'],
        ['Besk\u00e6ring h\u00f8jre', this._trimRight + ' cm'],
        ['Besk\u00e6ring top', this._trimTop + ' cm'],
        ['Besk\u00e6ring bund', this._trimBottom + ' cm'],
        ['Besk\u00e6ringsguide', 'Ja'],
      ];
      var priv = [
        ['_crop_x', this._cropX],
        ['_crop_y', this._cropY],
        ['_wall_width_cm', this._wallWidth],
        ['_wall_height_cm', this._wallHeight],
        ['_standard_width_cm', d.w],
        ['_standard_height_cm', d.h],
        ['_guide_version', '1.0'],
      ];

      var form = this._form;
      props.concat(priv).forEach(function (pair) {
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + pair[0] + ']';
        inp.value = pair[1];
        inp.classList.add('pw-cg__prop');
        form.appendChild(inp);
      });
    }

		    _updateManualFormProperties(selectedVariant) {
		      this._removeFormProperties();
		      if (!this._form || !this._manualConfirmed) return;

		      var variant = selectedVariant || this._currentVariant();
		      if (!variant) return;

	      var dims = this._dimsForVariant(variant);
	      var material = this._displayMaterial(this._materialForVariant(variant)) || this._materialForVariant(variant) || '';
		      var props = [
		        ['Valgt standardst\u00f8rrelse', dims ? this._formatDims(dims) : variant.title],
		        ['Materiale', material],
		        ['Manuelt standardst\u00f8rrelsesvalg', 'Ja'],
		        ['Besk\u00e6ringsguide', 'Manuelt valg'],
		      ];
		      var priv = [
		        ['_manual_size_confirmed', 'true'],
		        ['_guide_version', '1.0'],
		      ];
	      var form = this._form;

	      props.concat(priv).forEach(function (pair) {
	        if (!pair[1]) return;
	        var inp = document.createElement('input');
	        inp.type = 'hidden';
	        inp.name = 'properties[' + pair[0] + ']';
	        inp.value = pair[1];
	        inp.classList.add('pw-cg__prop');
	        form.appendChild(inp);
	      });
	    }

    _removeFormProperties() {
      if (!this._form) return;
      this._form.querySelectorAll('.pw-cg__prop').forEach(function (el) { el.remove(); });
    }

    /* ------------------------------------------------------------------ */
    /*  Crop modal                                                         */
    /* ------------------------------------------------------------------ */

    _openModal() {
      if (!this._recommendedVariant) return;
      var d = this._dimsForVariant(this._recommendedVariant);
      if (!d) return;

      this._standardWidth = d.w;
      this._standardHeight = d.h;

      var modal = this._modalElement;
      var preview = this.querySelector('.pw-cg__preview');
      if (!modal || !preview) return;

      preview.style.setProperty('--pw-cg-preview-ratio', d.w + ' / ' + d.h);

      // Set image
      var img = this.querySelector('.pw-cg__preview-img');
      if (img && !img.src && this._firstImage) {
        img.src = this._firstImage;
        img.alt = 'Forh\u00e5ndsvisning af fototapet';
      }

      // Move the modal to the body so it can render in the top layer without
      // any parent display/transform/grid constraints. We move it back on close.
      if (modal.parentElement !== document.body) {
        this._modalOriginalParent = modal.parentElement;
        this._modalOriginalNextSibling = modal.nextSibling;
        document.body.appendChild(modal);
      }

      // Wait for layout then position
      requestAnimationFrame(() => this._layoutPreview());

      modal.showModal();
      this._event('crop_opened', {
        variant_id: this._recommendedVariant.id,
        standard_width_cm: d.w,
        standard_height_cm: d.h,
      });
    }

    _closeModal() {
	      if (!this._modalElement) return;
	      this._modalElement.close();
	      if (this._modalOriginalParent) {
	        if (this._modalOriginalNextSibling) {
	          this._modalOriginalParent.insertBefore(this._modalElement, this._modalOriginalNextSibling);
	        } else {
	          this._modalOriginalParent.appendChild(this._modalElement);
	        }
	        this._modalOriginalParent = null;
	        this._modalOriginalNextSibling = null;
	      }
	    }

    _layoutPreview() {
      var container = this._modalElement && this._modalElement.querySelector('.pw-cg__preview');
      var img = this._modalElement && this._modalElement.querySelector('.pw-cg__preview-img');
      if (!container || !img) return;

      var cw = container.clientWidth;
      var ch = container.clientHeight;
      if (!cw || !ch) return;

      // Standard wallpaper aspect ratio
      var sRatio = this._standardWidth / this._standardHeight;
      var cRatio = cw / ch;
      var dw, dh;

      if (sRatio > cRatio) {
        dw = cw;
        dh = cw / sRatio;
      } else {
        dh = ch;
        dw = ch * sRatio;
      }

      img.style.width = dw + 'px';
      img.style.height = dh + 'px';
      img.style.left = ((cw - dw) / 2) + 'px';
      img.style.top = ((ch - dh) / 2) + 'px';

      this._previewScaleX = dw / this._standardWidth;
      this._previewScaleY = dh / this._standardHeight;
      this._previewOffsetX = (cw - dw) / 2;
      this._previewOffsetY = (ch - dh) / 2;

      this._positionCropFrame();
      this._updateTrimLabels();
    }

    _positionCropFrame() {
      var frame = this._modalElement && this._modalElement.querySelector('.pw-cg__crop-frame');
      if (!frame) return;

      var fw = this._wallWidth * this._previewScaleX;
      var fh = this._wallHeight * this._previewScaleY;
      var fx = this._cropX * this._previewScaleX + this._previewOffsetX;
      var fy = this._cropY * this._previewScaleY + this._previewOffsetY;

      frame.style.width = fw + 'px';
      frame.style.height = fh + 'px';
      frame.style.left = fx + 'px';
      frame.style.top = fy + 'px';

      // Show drag hint only when there is surplus
      var hint = this._modalElement && this._modalElement.querySelector('.pw-cg__drag-hint');
      if (hint) {
        var canDrag = this._standardWidth > this._wallWidth || this._standardHeight > this._wallHeight;
        hint.hidden = !canDrag;
      }
    }

    _clampCrop() {
      this._cropX = Math.max(0, Math.min(Math.round(this._cropX), Math.max(0, this._standardWidth - this._wallWidth)));
      this._cropY = Math.max(0, Math.min(Math.round(this._cropY), Math.max(0, this._standardHeight - this._wallHeight)));
    }

    _moveCropBy(dx, dy) {
      if (!this._standardWidth || !this._standardHeight) return;
      this._cropX += dx;
      this._cropY += dy;
      this._clampCrop();
      this._positionCropFrame();
      this._updateTrimLabels();
      this._cropConfirmed = false;
      this._updateConfirmationUI();
      this._removeFormProperties();
      this._saveState();
    }

    _updateTrimLabels() {
      this._calculateTrims();

      var labels = this._modalElement ? this._modalElement.querySelectorAll('.pw-cg__trim-val') : [];
      if (labels.length >= 4) {
        labels[0].textContent = this._trimLeft + ' cm';
        labels[1].textContent = this._trimRight + ' cm';
        labels[2].textContent = this._trimTop + ' cm';
        labels[3].textContent = this._trimBottom + ' cm';
      }

      this._updateTrimSummary();
    }

    _calculateTrims() {
      this._trimLeft = Math.round(this._cropX);
      this._trimTop = Math.round(this._cropY);
      this._trimRight = Math.round(this._standardWidth - this._wallWidth - this._cropX);
      this._trimBottom = Math.round(this._standardHeight - this._wallHeight - this._cropY);
    }

    _updateTrimSummary() {
      var el = this._modalElement && this._modalElement.querySelector('.pw-cg__trim-summary');
      if (!el) return;

      var parts = [
        this._trimLeft ? this._trimLeft + ' cm fra venstre' : null,
        this._trimRight ? this._trimRight + ' cm fra h\u00f8jre' : null,
        this._trimTop ? this._trimTop + ' cm fra toppen' : null,
        this._trimBottom ? this._trimBottom + ' cm fra bunden' : null,
      ].filter(Boolean);

      if (!parts.length) {
        el.hidden = true;
        el.textContent = '';
        return;
      }

      el.hidden = false;
      el.textContent = 'Du skal sk\u00e6re ' + parts.join(', ') + ' efter ops\u00e6tning.';
    }

    /* ------------------------------------------------------------------ */
    /*  Crop drag                                                          */
    /* ------------------------------------------------------------------ */

    _onPointerDown(e) {
      if (e.button && e.button !== 0) return;
      e.preventDefault();
      this._isDragging = true;
      this._dragStartX = e.clientX;
      this._dragStartY = e.clientY;
      this._dragOffsetX = this._cropX;
      this._dragOffsetY = this._cropY;

      var frame = this._modalElement && this._modalElement.querySelector('.pw-cg__crop-frame');
      if (frame) frame.setPointerCapture(e.pointerId);

      document.addEventListener('pointermove', this._onPointerMove);
      document.addEventListener('pointerup', this._onPointerUp);
      document.body.style.userSelect = 'none';
      document.body.style.webkitUserSelect = 'none';
    }

    _onPointerMove(e) {
      if (!this._isDragging) return;
      var dx = e.clientX - this._dragStartX;
      var dy = e.clientY - this._dragStartY;

      var nx = this._dragOffsetX + dx / this._previewScaleX;
      var ny = this._dragOffsetY + dy / this._previewScaleY;

      nx = Math.max(0, Math.min(nx, this._standardWidth - this._wallWidth));
      ny = Math.max(0, Math.min(ny, this._standardHeight - this._wallHeight));

      this._cropX = Math.round(nx);
      this._cropY = Math.round(ny);
      this._clampCrop();

      this._positionCropFrame();
      this._updateTrimLabels();
    }

    _onPointerUp() {
      this._isDragging = false;
      document.removeEventListener('pointermove', this._onPointerMove);
      document.removeEventListener('pointerup', this._onPointerUp);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';

      this._event('crop_adjusted', { crop_x_cm: this._cropX, crop_y_cm: this._cropY });
      this._saveState();
    }

    _onCropKeydown(e) {
      var keyMap = {
        ArrowLeft: [-1, 0],
        ArrowRight: [1, 0],
        ArrowUp: [0, -1],
        ArrowDown: [0, 1],
      };
      var delta = keyMap[e.key];
      if (!delta) return;

      e.preventDefault();
      var step = e.shiftKey ? 10 : 1;
      this._moveCropBy(delta[0] * step, delta[1] * step);
      this._event('crop_adjusted', { crop_x_cm: this._cropX, crop_y_cm: this._cropY, input: 'keyboard' });
    }

    _onWindowResize() {
	      var modal = this._modalElement;
	      if (modal && modal.open) requestAnimationFrame(() => this._layoutPreview());
	    }

    /* ------------------------------------------------------------------ */
    /*  Crop confirmation                                                  */
    /* ------------------------------------------------------------------ */

    _confirmCrop() {
	      this._cropConfirmed = true;
	      this._manualMode = false;
	      this._manualConfirmed = false;
	
	      if (this._recommendedVariant) {
        this._selectVariantOptions(this._recommendedVariant);
      }
      this._updateConfirmationUI();
      this._closeModal();
      this._updateFormProperties();
      this._saveState();

      this._event('crop_confirmed', {
        crop_x_cm: this._cropX,
        crop_y_cm: this._cropY,
        trim_left_cm: this._trimLeft,
        trim_right_cm: this._trimRight,
        trim_top_cm: this._trimTop,
        trim_bottom_cm: this._trimBottom,
      });
    }

	    _updateConfirmationUI() {
	      this._updateModeClasses();
		      var confirmed = this._assistedActive && this._cropConfirmed;
	      var summary = this.querySelector('.pw-cg__summary');
	      var checkbox = this.querySelector('.pw-cg__confirm-cb');
	      var cropButton = this.querySelector('.pw-cg__open-crop-btn');

	      if (summary) {
        summary.hidden = !confirmed;
        if (confirmed && this._recommendedVariant) {
          var d = this._dimsForVariant(this._recommendedVariant);
          var sizeEl = summary.querySelector('.pw-cg__summary-size');
          if (sizeEl && d) sizeEl.textContent = d.w + ' \u00d7 ' + d.h + ' cm';
        }
	      }
	      if (checkbox) checkbox.checked = confirmed;
	      if (cropButton) {
	        cropButton.classList.toggle('pw-cg__secondary-btn', confirmed);
	        cropButton.textContent = confirmed ? 'Ret besk\u00e6ring' : 'Kontroll\u00e9r besk\u00e6ring';
	      }

		      this._updateBuyButtonState();
		      this._syncStage();
		    }

	    _updateModeClasses() {
	      this.classList.toggle('pw-cg--manual-active', !!this._manualMode);
	      this.classList.toggle('pw-cg--manual-confirmed', !!this._manualConfirmed);
	      this.classList.toggle('pw-cg--assisted-active', !!this._assistedActive);
	      this.classList.toggle('pw-cg--crop-confirmed', !!this._cropConfirmed);

	      var resetBtn = this.querySelector('.pw-cg__reset-btn');
	      if (resetBtn) {
	        resetBtn.hidden = !(this._manualMode || this._manualConfirmed || this._assistedActive || this._recommendedVariant || this._cropConfirmed);
	      }

	      var manualSize = document.querySelector('variant-picker[form-id="' + this._formId + '"] details.pw-cg-manual-size');
	      if (manualSize) {
	        manualSize.classList.toggle('pw-cg-manual-size--manual-active', !!this._manualMode);
	        manualSize.classList.toggle('pw-cg-manual-size--assisted-active', !!this._assistedActive);
	      }
	    }

	    _updateBuyButtonState() {
	      if (!this._formId) return;
	      var buttons = document.querySelectorAll('button[type="submit"][form="' + this._formId + '"], form#' + this._formId + ' button[type="submit"]');
	      var currentVariant = this._recommendedVariant || this._currentVariant();
	      var variantUnavailable = currentVariant && currentVariant.available === false;
	      var canAdd = !variantUnavailable && ((this._assistedActive && this._cropConfirmed && this._recommendedVariant) || this._manualConfirmed);
	      var helperText = '';
	      var buttonText = 'L\u00e6g i kurv';

	      if (variantUnavailable) {
	        buttonText = 'Udsolgt';
	        helperText = '';
      } else if (this._assistedActive && this._cropConfirmed && this._recommendedVariant) {
        buttonText = 'L\u00e6g i kurv \u2013 ' + this._fmtPrice(this._recommendedVariant.price);
      } else if (this._manualConfirmed && currentVariant) {
        buttonText = 'L\u00e6g i kurv \u2013 ' + this._fmtPrice(currentVariant.price);
      } else if (this._assistedActive && this._recommendedVariant) {
        helperText = 'Godkend besk\u00e6ring f\u00f8rst';
      } else if (this._manualMode) {
        helperText = 'V\u00e6lg en standardst\u00f8;rrelse';
      } else {
        helperText = 'Indtast v\u00e6ggens m\u00e5l';
      }

	      buttons.forEach((button) => {
	        if (!button.dataset.pwCgOriginalText) button.dataset.pwCgOriginalText = button.textContent.trim();
	        button.disabled = !canAdd;
	        if (!canAdd) {
	          button.setAttribute('aria-disabled', 'true');
	          button.classList.add('pw-cg-atc-needs-confirmation');
	          button.textContent = buttonText;
	        } else {
	          button.removeAttribute('aria-disabled');
	          button.classList.remove('pw-cg-atc-needs-confirmation');
	          button.textContent = buttonText;
	        }

	        this._updateAtcHelper(button, helperText);
	      });
	    }

    _updateAtcHelper(button, text) {
      var host = button.closest('buy-buttons') || button.parentElement;
      if (!host) return;

      var helper = host.querySelector('.pw-cg__atc-helper');
      if (!text) {
        if (helper) helper.remove();
        return;
      }

      if (!helper) {
        helper = document.createElement('button');
        helper.type = 'button';
        helper.className = 'pw-cg__atc-helper';
        host.appendChild(helper);
        helper.addEventListener('click', (e) => {
          e.preventDefault();
          var calcToggle = this.querySelector('.pw-cg__calc-toggle');
          if (calcToggle && !calcToggle.open) {
            calcToggle.open = true;
          }
          var cropBtn = this.querySelector('.pw-cg__open-crop-btn');
          if (cropBtn && this._assistedActive && this._recommendedVariant && !this._cropConfirmed) {
            cropBtn.click();
          }
          this.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      }

      helper.textContent = '\u2193 ' + text;
    }

	    _currentVariant() {
	      var id = this._currentVariantId();
	      return this._variants.find((v) => v.id === id) || null;
	    }

    /* ------------------------------------------------------------------ */
    /*  Analytics                                                          */
    /* ------------------------------------------------------------------ */

    _event(name, data) {
      if (!this._hasAnalyticsConsent()) return;
      window.dataLayer = window.dataLayer || [];
      var payload = Object.assign({ product_handle: this._productHandle }, data || {});
      window.dataLayer.push({ event: 'crop_guide_' + name, crop_guide: payload });
    }

    _hasAnalyticsConsent() {
      if (window.ntInternalAnalyticsOptOut) return false;
      try {
        if (window.localStorage.getItem('nt_cookie_consent_decision') === 'accepted') return true;
      } catch (_) {}
      return document.cookie.split(';').some(function (cookie) {
        return cookie.trim() === 'nt_cookie_consent_decision=accepted';
      });
    }

    _trackCalculatorOpened() {
      if (this._calculatorOpened) return;
      this._calculatorOpened = true;
      this._event('calculator_opened', { variant_id: this._currentVariantId() });
    }

    _eventPayload() {
      var variant = this._recommendedVariant;
      var dims = variant ? this._dimsForVariant(variant) : null;
      return {
        variant_id: variant ? variant.id : this._currentVariantId(),
        material: this._materialForVariant(variant),
        standard_width_cm: dims ? dims.w : null,
        standard_height_cm: dims ? dims.h : null,
        wall_width_cm: this._wallWidth || null,
        wall_height_cm: this._wallHeight || null,
        trim_left_cm: this._trimLeft,
        trim_right_cm: this._trimRight,
        trim_top_cm: this._trimTop,
        trim_bottom_cm: this._trimBottom,
      };
    }

    /* ------------------------------------------------------------------ */
    /*  State persistence (sessionStorage)                                 */
    /* ------------------------------------------------------------------ */

    _storageKey() { return 'pw-cg-' + this._productHandle; }

    _saveState() {
      try {
        sessionStorage.setItem(this._storageKey(), JSON.stringify({
          ww: this._wallWidth,
          wh: this._wallHeight,
		            vid: this._recommendedVariant ? this._recommendedVariant.id : (this._manualConfirmed ? this._currentVariantId() : null),
          cx: this._cropX,
	          cy: this._cropY,
	          cc: this._cropConfirmed,
	          aa: this._assistedActive,
	          mm: this._manualMode,
	          mc: this._manualConfirmed,
	        }));
      } catch (_) { /* private mode etc. */ }
    }

    _restoreState() {
      try {
        var raw = sessionStorage.getItem(this._storageKey());
        if (!raw) return;
        var s = JSON.parse(raw);

        var wInput = this.querySelector('.pw-cg__width');
        var hInput = this.querySelector('.pw-cg__height');
        if (wInput && s.ww) wInput.value = s.ww;
        if (hInput && s.wh) hInput.value = s.wh;

        if (s.mc) {
          var storedManualVariant = this._variants.find((v) => v.id === Number(s.vid)) || this._currentVariant();
          this._manualMode = true;
          this._manualConfirmed = !!storedManualVariant;
          this._assistedActive = false;
          this._cropConfirmed = false;
          this._recommendedVariant = null;

          if (storedManualVariant) {
            this._selectVariantOptions(storedManualVariant);
            this._updateManualSizeSummary(storedManualVariant, true);
            this._updateManualFormProperties(storedManualVariant);
            this._updateMainPriceDisplay(storedManualVariant);
          }
          this._updateBuyButtonState();
        }

	        if (!s.aa || !s.ww || !s.wh) return;
        this._wallWidth = s.ww;
        this._wallHeight = s.wh;
        this._assistedActive = true;

        var storedVariant = this._variants.find((v) => v.id === Number(s.vid));
        var storedMaterial = this._materialForVariant(storedVariant);
        var res = this._recommend(s.ww, s.wh, storedMaterial || this._selectedMaterial());
        if (res) {
	          this._recommendedVariant = res.v;
	          this._cropX = Number.isFinite(Number(s.cx)) ? Number(s.cx) : Math.round((res.d.w - s.ww) / 2);
	          this._cropY = Number.isFinite(Number(s.cy)) ? Number(s.cy) : Math.round((res.d.h - s.wh) / 2);
	          this._showMsg('recommendation', res);
	          this._setCalculationCtaState(true);
	          this._selectVariantOptions(res.v);
          this._cropConfirmed = !!s.cc;
          this._standardWidth = res.d.w;
          this._standardHeight = res.d.h;
          this._calculateTrims();
          this._updateConfirmationUI();
          if (this._cropConfirmed) this._updateFormProperties();
        }
      } catch (_) { /* ignore */ }
    }
  }

  window.customElements.define('photo-wallpaper-crop-guide', PhotoWallpaperCropGuide);
})();
